export const SET_LIST_UPLOADED_FILES = 'SET_LIST_UPLOADED_FILES'
export const INFINITE_SET_LIST_UPLOADED_FILES = 'INFINITE_SET_LIST_UPLOADED_FILES'
export const SET_UPLOAD_FILE_STATUS = 'SET_UPLOAD_FILE_STATUS'
export const SET_IS_FETCHING_LIST = 'SET_IS_FETCHING_LIST'
export const SET_IS_FETCHING_STATUS = 'SET_IS_FETCHING_STATUS'
export const SET_LIST_NEXT_CURSOR = 'SET_LIST_NEXT_CURSOR'
